/* src/app/shared/components/ag-tab/ag-tab.component.scss */
.tab-wrapper {
  height: 56px;
  display: flex;
  border-bottom: 1px solid #dfdfdf;
  overflow-y: visible;
  position: relative;
}
.tab-wrapper .active-indicator {
  position: absolute;
  bottom: -1px;
  left: 0;
  height: 2px;
  transition:
    transform 0.2s ease,
    width 0.2s ease,
    background-color 0.15s ease;
  pointer-events: none;
  border-radius: 2px;
}
.tab-wrapper .ag-tab {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 16px 16px 14px;
  cursor: pointer;
  height: 56.1px;
}
.tab-wrapper .ag-tab img {
  width: 24px;
  height: 24px;
  filter: var(--inactive-filter);
  transition: filter 0.2s ease;
}
.tab-wrapper .ag-tab.active img {
  filter: var(--active-filter);
}
.tab-wrapper .ag-tab.disabled {
  cursor: not-allowed;
}
.tab-wrapper .ag-tab.disabled img {
  filter: brightness(0) saturate(100%) invert(87.5%) !important;
}
.tab-wrapper .ag-tab.disabled h4 {
  color: #dfdfdf !important;
}
.tab-wrapper .ag-tab:hover:not(.disabled) img {
  filter: var(--active-filter);
}
.tab-wrapper .ag-tab:hover:not(.disabled) h4 {
  color: var(--active-color) !important;
}
/*# sourceMappingURL=ag-tab.component.css.map */
